import { useState } from "react";
import { ECountry } from "common/enums/Country/ECountry";
import SubscriptionResponseResource from "common/resources/Subscription/SubscriptionResponseResource";
import InputElement, { EInputType } from "components/materials/Form/InputElement";
import CountrySelectInputElement from "components/materials/Form/CountrySelectInputElement";
import I18n from "components/materials/I18n";
import QuestionCategory from "components/pages/Subscriptions/physicalPerson/SubscriptionQuestions/QuestionCategory";

export default function HexaBankDetails({ subscription }: { subscription: SubscriptionResponseResource }) {
	const [country, setCountry] = useState(subscription.perceptionBankCountry);
	return (
		<QuestionCategory title="Compte bancaire de l’investisseur (Hexa)">
			<p>Recopiez les coordonnées du compte détenu par le souscripteur. Elles complètent l’annexe bancaire du bulletin. Les champs facultatifs sont indiqués.</p>
			<InputElement name="perceptionTitularyName" defaultValue={subscription.perceptionTitularyName ?? ""} label="Titulaire du compte (facultatif)" type={EInputType.TEXT} />
			<InputElement name="perceptionBankDomiciliation" defaultValue={subscription.perceptionBankDomiciliation ?? ""} label="Nom de la banque" type={EInputType.TEXT} />
			<CountrySelectInputElement
				name="perceptionBankCountry"
				label="Pays de la banque"
				defaultValue={
					subscription.perceptionBankCountry ? { id: subscription.perceptionBankCountry, label: I18n.asset.enums.ECountry[subscription.perceptionBankCountry] } : null
				}
				onChange={(_, value) => setCountry(value?.id as ECountry | undefined)}
			/>
			<InputElement name="perceptionBankAddress" defaultValue={subscription.perceptionBankAddress ?? ""} label="Adresse de la banque" type={EInputType.TEXT} />
			<InputElement name="perceptionBankCity" defaultValue={subscription.perceptionBankCity ?? ""} label="Ville de la banque" type={EInputType.TEXT} />
			<InputElement name="perceptionBankZipCode" defaultValue={subscription.perceptionBankZipCode ?? ""} label="Code postal de la banque" type={EInputType.TEXT} />
			<InputElement
				name="perceptionAccountNumber"
				defaultValue={subscription.perceptionAccountNumber ?? ""}
				label="Numéro de compte (facultatif)"
				caption="Numéro indiqué par la banque, distinct de l’IBAN."
				type={EInputType.TEXT}
			/>
			<InputElement name="perceptionBic" defaultValue={subscription.perceptionBic ?? ""} label="Code SWIFT / BIC" type={EInputType.TEXT} />
			<InputElement name="perceptionIban" defaultValue={subscription.perceptionIban ?? ""} label="IBAN" format="iban" type={EInputType.TEXT} />
			{country === ECountry.etats_unis && (
				<InputElement
					name="perceptionAba"
					defaultValue={subscription.perceptionAba ?? ""}
					label="Code ABA (routing number, 9 chiffres) (facultatif)"
					type={EInputType.TEXT}
				/>
			)}
			<InputElement
				name="perceptionBankContact"
				defaultValue={subscription.perceptionBankContact ?? ""}
				label="Coordonnées du contact bancaire (facultatif)"
				type={EInputType.TEXT}
				caption="Nom du conseiller ou du service, et e-mail ou numéro de téléphone."
			/>
		</QuestionCategory>
	);
}
